module.exports = __webpack_public_path__ + "img/bcvault.35fab6ca.svg";